import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Edizione } from "../../types"
import EdizioneForm from "./EdizioneForm"
import { Button } from "@inmagik/magik-ui"
import { initialValuesEdizione, validationSchemaEdizione } from "./EdizioneCommon"
import { useMemo } from "react"

export default function EdizioneModal({
  title,
  edizione,
  save,
  show,
  onClose,
  showOpera = false,
}: {
  title: string
  edizione?: Edizione
  save: (values: Edizione) => Promise<void>
  show: boolean
  onClose: () => void
  showOpera?: boolean
}) {

  const initialValues = useMemo(() => initialValuesEdizione(edizione) as Edizione, [edizione])
  const validationSchema = useMemo(() => validationSchemaEdizione(showOpera), [showOpera])

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                height: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <EdizioneForm showOpera={showOpera} col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
